/* unplugin-vue-components disabled */import { render } from "./HeaderPcM.vue?vue&type=template&id=146c6e6a&scoped=true"
import script from "./HeaderPcM.vue?vue&type=script&lang=js"
export * from "./HeaderPcM.vue?vue&type=script&lang=js"

import "./HeaderPcM.vue?vue&type=style&index=0&id=146c6e6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146c6e6a"]])

export default __exports__